import {
  GET_OPSGENIE_TEAMS,
  GET_OPSGENIE_TEAMS_FAIL,
  GET_OPSGENIE_TEAMS_SUCCESS,
  GET_REFRESH_OPSGENIE_SUCCESS,
  GET_REFRESH_OPSGENIE_FAIL,
  GET_REFRESH_OPSGENIE
} from "./actionTypes";

export const getOpsGenieTeams = () => ({
  type: GET_OPSGENIE_TEAMS,
})

export const getOpsGenieTeamsSuccess = users => ({
  type: GET_OPSGENIE_TEAMS_SUCCESS,
  payload: users,
})

export const getOpsGenieTeamsFail = error => ({
  type: GET_OPSGENIE_TEAMS_FAIL,
  payload: error,
})

export const getOpsGenieRefresh = () => ({
  type: GET_REFRESH_OPSGENIE,
})

export const getOpsGenieRefreshSuccess = teams => ({
  type: GET_REFRESH_OPSGENIE_SUCCESS,
  payload: teams,
})

export const getOpsGenieRefreshFail = error => ({
  type: GET_REFRESH_OPSGENIE_FAIL,
  payload: error,
})

